import React, {useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import {setShowModal} from "../../../services/redux/actions/app-actions";

import {Box, FormControl, InputLabel, NativeSelect} from "@material-ui/core";

import {addHunter, getHuntersListForHead} from "../../../pages/huntersPlan/api";
import CustomButton from "../../UI/Button";
import {monthList, yearList} from "../../../utils/dates";
import NumberFormatInput from "../../UI/NumberFormatInput";
import {getSaleDeptId} from "../../../pages/salesDeptPlan/api";
import AutoSuggest from "../../UI/AutoSuggest";
import cookiesService from "../../../services/cookiesService";
import {useCustomSnackbar} from "../../../utils/hooks/useCustomSnackbar";
import {getHunters} from "../../../pages/deals/view/api";
import {
  clampToV2Month,
  filterV2Months,
  filterV2Years,
} from "../../../pages/huntersKpi/cutover";

const cookiesServiceInstance = cookiesService.getService()
const AddHunter = ({state, setHuntersPlan}) => {
  const {position_code, sale_department_id} = cookiesServiceInstance.getUserData();
  const dispatch = useDispatch();
  const [huntersArr, setHuntersArr] = useState([]);
  const initialPeriod = clampToV2Month(
    state?.year || new Date().getFullYear(),
    state?.month || new Date().getMonth() + 1
  );
  const [addHunterState, setAddHunterState] = useState({
    employee_id: null,
    month: initialPeriod.month,
    year: initialPeriod.year,
    hunter_salary: null,
    hunter_month_plan_sum: null,
    sale_department_id: sale_department_id ? sale_department_id : null
  });
  const [saleDept, setSaleDept] = useState([]);
  const {addDefaultSnack} = useCustomSnackbar();
  const years = filterV2Years(yearList);
  const months = filterV2Months(monthList, addHunterState.year);

  useEffect(() => {
    getSaleDeptId().then(res => {
      setSaleDept(res);
    });
  }, []);

  const handleChange = e => {
    const {name, value} = e.target;
    const next = {
      ...addHunterState,
      [name]: value === "" ? null : +value
    };
    if (name === "year" || name === "month") {
      const clamped = clampToV2Month(
        next.year || initialPeriod.year,
        next.month || initialPeriod.month
      );
      next.year = clamped.year;
      next.month = clamped.month;
    }
    setAddHunterState(next);

    if (position_code === "SALE_HEAD_HEAD") {
      if (name === "sale_department_id") {
        getHuntersListForHead(value).then(res => {
          setHuntersArr(res);
        });
      }
    }
  };

  useEffect(() => {
    if (sale_department_id) {
      getHunters(sale_department_id).then(res => {
        setHuntersArr(res);
      });
    }
  }, [sale_department_id]);

  const handleAdd = () => {
    const period = clampToV2Month(addHunterState.year, addHunterState.month);
    addHunter(period.year, period.month, {
      ...addHunterState,
      year: period.year,
      month: period.month,
    })
      .then(res => {
        setHuntersPlan(res);
        dispatch(setShowModal(false));
        addDefaultSnack("Успешно изменен");
      })
      .catch(() => {
      });
  };

  return (
    <Box sx={{width: 400}}>
      <Box sx={{margin: "20px 0"}}>
        <Box sx={{minWidth: 300}}>
          <FormControl fullWidth disabled={sale_department_id}>
            <InputLabel htmlFor="select-sd" shrink={sale_department_id}>
              ОП
            </InputLabel>
            <NativeSelect
              onChange={handleChange}
              value={addHunterState.sale_department_id || sale_department_id || ""}
              inputProps={{
                name: "sale_department_id",
                id: "select-sd"
              }}
            >
              <option value=""/>
              {saleDept.map(el => {
                return (
                  <option
                    value={el.sale_department_id}
                    key={el.sale_department_id}
                  >
                    {el.sale_department_name}
                  </option>
                );
              })}
            </NativeSelect>
          </FormControl>
        </Box>
        <Box sx={{minWidth: 300}}>
          <AutoSuggest
            label="Хантер"
            name="employee_id"
            list={huntersArr}
            valueKey="employee_id"
            showKey="fio"
            onChange={handleChange}
            disabled={!huntersArr.length}
          />
        </Box>
        <Box
          sx={{display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px"}}
        >
          <FormControl fullWidth>
            <InputLabel htmlFor="month-select">Месяц</InputLabel>
            <NativeSelect
              value={addHunterState.month}
              onChange={handleChange}
              inputProps={{
                name: "month",
                id: "month-select"
              }}
            >
              <option aria-label="" value=""/>
              {months.map(el => {
                return (
                  <option value={el.id} key={el.id}>
                    {el.month}
                  </option>
                );
              })}
            </NativeSelect>
          </FormControl>
          <FormControl fullWidth>
            <InputLabel htmlFor="select-year">Год</InputLabel>
            <NativeSelect
              value={addHunterState.year}
              onChange={handleChange}
              inputProps={{
                name: "year",
                id: "select-year"
              }}
            >
              <option aria-label="" value=""/>
              {years.map(el => {
                return (
                  <option value={el.year} key={el.id}>
                    {el.year}
                  </option>
                );
              })}
            </NativeSelect>
          </FormControl>
        </Box>
        <Box sx={{display: "grid"}}>
          <NumberFormatInput
            name="hunter_salary"
            label="Оклад"
            value={addHunterState.hunter_salary || ""}
            handleChange={handleChange}
          />
          <NumberFormatInput
            name="hunter_month_plan_sum"
            label="План"
            value={addHunterState.hunter_month_plan_sum || ""}
            handleChange={handleChange}
          />
        </Box>
      </Box>
      <Box sx={{width: 200, marginLeft: "auto"}}>
        <CustomButton btnText="Добавить" handleClick={handleAdd}/>
      </Box>
    </Box>
  );
};

export default AddHunter;
